import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { lower } from 'change-case'
import { reduxForm, Field } from 'redux-form'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { IconButton, Collapse, Card, CardHeader, CardContent } from '@material-ui/core'
import { ExpandMore, ExpandLess } from '@material-ui/icons'
import { Grid, Label } from 'semantic-ui-react'
import { VendorInformationContainer, ContactContainer, ExperienceContainer } from './styled'
import { getHrmsMembers, getAllMembers } from 'ducks/member'
import { getBusinessPartners } from 'ducks/options'
import { getVendorDetail } from 'ducks/shortList'
import { Table, TableBody, TableRow, TableHead, TableCell, TableContainer, Paper } from '@material-ui/core'
import r from 'reactotron-react-js'

const VendorInformation = (props) => {
  const { valueForm, change, isDisplay = false, members, businessPartners, showCollapse = true } = props
  const [showVendorInfo, setShowVendorInfo] = useState(true)

  useEffect(() => {
    if (!members.data.length && !members.loading) {
      // props.getHrmsMembers()
      props.getAllMembers()
    }

    if (!businessPartners.data.length && !businessPartners.loading) {
      props.getBusinessPartners()
    }
  }, [])

  const editableForm = () => {
    if (valueForm.status !== 0 && valueForm.status !== undefined && valueForm.status !== null) {
      return !isDisplay && (valueForm.sn !== undefined && valueForm.sn !== null && valueForm.sn !== '')
    } else {
      return !isDisplay
    }
  }

  const vendorDataEditable = (index) => {
    return editableForm() && valueForm.vendors && valueForm.vendors[index] ? true : false
  }

  const memberOptions = members.data.map(m => ({ value: lower(m.username), text: `${m.firstnameEn} ${m.lastnameEn}` }))
  var docYear = (valueForm.documentDate || new Date()).getFullYear()
  docYear = docYear < 2500 ? docYear + 543 : docYear
  const docYears = [docYear - 1, docYear - 2, docYear - 3, docYear - 4, docYear - 5]

  const vendorLength = () => {
    var vl = valueForm && valueForm.vendors ? (valueForm.vendors || []).length : 0

    return vl > 3 ? vl : 3
  }

  const renderVendorName = () => (
    <TableRow>
      <TableCell variant='head' style={{ fontWeight: 'bold' }}></TableCell>
      {
        [...Array(vendorLength())].map((e, i) => {
          const vendorCode = valueForm.vendors && valueForm.vendors[i] ? valueForm.vendors[i].vendorCode || '' : ''
          const vendor = businessPartners.data.find(v => v.value === vendorCode)
          const vendorName = (vendor ? vendor.text : '').replace(`${vendorCode} : `, '')

          return (
            <TableCell style={{ fontWeight: 'bold', verticalAlign: 'top' }}>
              <Grid columns='equal' style={{ marginBottom: 'unset' }}>
                <Grid.Row style={{ paddingBottom: vendorName ? '5px' : '' }}>
                  <Grid.Column floated='left'>{`Vendor ${i + 1} ${vendorCode ? `(${vendorCode})` : ''}`}</Grid.Column>
                </Grid.Row>
                {vendorName ? <Grid.Row style={{ paddingTop: '0px' }}><Grid.Column>{vendorName}</Grid.Column></Grid.Row> : null}
              </Grid>
            </TableCell>
          )
        })
      }
    </TableRow>
  )

  const renderContact = () => (
    <TableRow>
      <TableCell variant='head' width={2} style={{ fontWeight: 'bold', verticalAlign: 'top' }}>Contact Name</TableCell>
      {
        [...Array(vendorLength())].map((e, i) => {
          const value = valueForm.vendors && valueForm.vendors[i] ? valueForm.vendors[i].contacts || [] : []

          return (
            <TableCell style={{ verticalAlign: 'top' }}>
              <ContactContainer>
                {
                  value.map(u => {
                    return (
                      <div className='contactRow'>
                        <div>{u.name}</div>
                        <div>{u.tel}</div>
                        <div>{u.email}</div>
                      </div>
                    )
                  })
                }
              </ContactContainer>
            </TableCell>
          )
        })
      }
    </TableRow>
  )

  const renderAddress = () => (
    <TableRow>
      <TableCell variant='head' width={2} style={{ fontWeight: 'bold' }}>Address</TableCell>
      {
        [...Array(vendorLength())].map((e, i) => 
          <TableCell>
            <Field
              name={`vendors[${i}].address`}
              editable={false}
              containerStyle={{ margin: '0px' }}
              style={{ margin: '0px' }}
              type={type.textArea}
              component={FieldInput}
            />
          </TableCell>
        )
      }
    </TableRow>
  )

  const renderProposeBy = () => (
    <TableRow>
      <TableCell variant='head' style={{ fontWeight: 'bold' }}>Propose by</TableCell>
      {
        [...Array(vendorLength())].map((e, i) => {
          return (
            <TableCell>
              <Field
                name={`vendors[${i}].proposeBy`}
                editable={false}
                loading={members.loading}
                containerStyle={{ margin: '0px' }}
                style={{ margin: '0px' }}
                options={memberOptions}
                type={type.select}
                component={FieldInput} />
            </TableCell>
          )
        })
      }
    </TableRow>
  )

  const renderYearEstablished = () => (
    <TableRow>
      <TableCell variant='head' width={2} style={{ fontWeight: 'bold' }}>ปีที่ก่อตั้ง</TableCell>
      {
        [...Array(vendorLength())].map((e, i) => 
          <TableCell>
            <Field
              name={`vendors[${i}].yearEstablished`}
              editable={false}
              containerStyle={{ margin: '0px' }}
              style={{ margin: '0px' }}
              type={type.text}
              component={FieldInput}
            />
          </TableCell>
        )
      }
    </TableRow>
  )

  const renderRegisteredCapital = () => (
    <TableRow>
      <TableCell variant='head' width={2} style={{ fontWeight: 'bold' }}>ทุนจดทะเบียน</TableCell>
      {[...Array(vendorLength())].map((e, i) => renderNumberField(`vendors[${i}].registeredCapital`, i))}
    </TableRow>
  )

  const renderIncome = () => {
    var result = [<TableRow><TableCell variant='head' colSpan={`${vendorLength() + 1}`} style={{ fontWeight: 'bold' }}>รายรับ (ย้อนหลัง 3-5 ปี)</TableCell></TableRow>]

    docYears.forEach((year, yearIndex) => {
      var elements = []
      for (let index = 0; index < vendorLength(); index++) {
        if (index === 0) {
          elements = [<TableCell variant='head' width={2} style={{ fontWeight: 'bold' }}>{year}</TableCell>]
        }
        elements.push(renderNumberField(`vendors[${index}].incomes[${yearIndex}].value`, index))
      }

      result.push(<TableRow>{elements}</TableRow>)
    })

    return result
  }

  const renderProfit = () => {
    var result = [<TableRow><TableCell variant='head' colSpan={`${vendorLength() + 1}`} style={{ fontWeight: 'bold' }}>กำไร/ขาดทุน (ย้อนหลัง 3-5 ปี)</TableCell></TableRow>]

    docYears.forEach((year, yearIndex) => {
      var elements = []
      for (let index = 0; index < vendorLength(); index++) {
        if (index === 0) {
          elements = [<TableCell variant='head' width={2} style={{ fontWeight: 'bold' }}>{year}</TableCell>]
        }
        elements.push(renderNumberField(`vendors[${index}].profits[${yearIndex}].value`, index))
      }

      result.push(<TableRow>{elements}</TableRow>)
    })

    return result
  }

  const renderShareholder = () => {
    var result = [<TableRow><TableCell variant='head' colSpan={`${vendorLength() + 1}`} style={{ fontWeight: 'bold' }}>ส่วนของผู้ถือหุ้น (ย้อนหลัง 3-5 ปี)</TableCell></TableRow>]

    docYears.forEach((year, yearIndex) => {
      var elements = []
      for (let index = 0; index < vendorLength(); index++) {
        if (index === 0) {
          elements = [<TableCell variant='head' width={2} style={{ fontWeight: 'bold' }}>{year}</TableCell>]
        }
        elements.push(renderNumberField(`vendors[${index}].shareholders[${yearIndex}].value`, index))
      }

      result.push(<TableRow>{elements}</TableRow>)
    })

    return result
  }

  const renderNumberField = (name, index) => (
    <TableCell>
      <Field
        name={name}
        editable={false}
        containerStyle={{ margin: '0px' }}
        style={{ margin: '0px' }}
        type={type.number}
        component={FieldInput}
      />
    </TableCell>
  )

  const renderExperience = () => (
    <TableRow>
      <TableCell variant='head' width={2} style={{ fontWeight: 'bold', verticalAlign: 'top' }}>ประสบการณ์</TableCell>
      {
        [...Array(vendorLength())].map((e, i) => {
          const value = valueForm.vendors && valueForm.vendors[i] ? valueForm.vendors[i].experience || [] : []

          return (
            <TableCell style={{ verticalAlign: 'top' }}>
              <ExperienceContainer>
                {value.map((ex, i) => <div>{`${i + 1}. ${ex}`}</div>)}
              </ExperienceContainer>
            </TableCell>
          )
        })
      }
    </TableRow>
  )

  const renderPqPart = () => {
    var { pqs } = valueForm

    if (pqs.length > 0) {
      return (
        <React.Fragment>
          <TableRow style={{ background: '#F5F5F5' }}><TableCell variant='head' colSpan={`${vendorLength() + 1}`} style={{ fontWeight: 'bold' }}>Pre-Q Part A</TableCell></TableRow>
          <TableRow>
            <TableCell variant='head' width={2} style={{ fontWeight: 'bold' }}>Score</TableCell>
            {
              [...Array(vendorLength())].map((e, i) => {
                const vendor = valueForm.vendors && valueForm.vendors[i] ? valueForm.vendors[i] : {}
                const pq = pqs.find(x => x.shortListVendorId === vendor.id )

                return (
                  <TableCell style={{ verticalAlign: 'top', textAlign: 'right' }}>{pq.score}</TableCell>
                )
              })
            }
          </TableRow>
          <TableRow>
            <TableCell variant='head' width={2} style={{ fontWeight: 'bold' }}>Percentage</TableCell>
            {
              [...Array(vendorLength())].map((e, i) => {
                const vendor = valueForm.vendors && valueForm.vendors[i] ? valueForm.vendors[i] : {}
                const pq = pqs.find(x => x.shortListVendorId === vendor.id )

                return (
                  <TableCell style={{ verticalAlign: 'top', textAlign: 'right' }}>{Number(pq.percentage).toFixed(2)} %</TableCell>
                )
              })
            }
          </TableRow>
          <TableRow>
            <TableCell variant='head' width={2} style={{ fontWeight: 'bold' }}>Result</TableCell>
            {
              [...Array(vendorLength())].map((e, i) => {
                const vendor = valueForm.vendors && valueForm.vendors[i] ? valueForm.vendors[i] : {}
                const pq = pqs.find(x => x.shortListVendorId === vendor.id )

                return (
                  <TableCell style={{ verticalAlign: 'top', textAlign: 'right' }}>
                    <React.Fragment>
                      <Label color={Number(pq.percentage) >= 70 ? 'green' : 'gray'}>ผ่าน</Label>
                      <Label color={Number(pq.percentage) >= 70 ? 'gray' : 'red'}>ไม่ผ่าน</Label>
                    </React.Fragment>
                  </TableCell>
                )
              })
            }
          </TableRow>
        </React.Fragment>
        
      )
    } else {
      return null
    }
  }

  const renderCommitteeEvaluationPart = () => {
    return (
      <React.Fragment>
        <TableRow>
          <TableCell variant='head' width={2} style={{ fontWeight: 'bold' }}>Evaluation</TableCell>
          {
            [...Array(vendorLength())].map((e, i) => 
              <TableCell>
                <Field
                  name={`vendors[${i}].evaluation`}
                  editable={true}
                  containerStyle={{ margin: '0px' }}
                  style={{ margin: '0px' }}
                  options={[{value: true, text: 'ผ่าน'}, {value: false, text: 'ไม่ผ่าน'}]}
                  type={type.radio}
                  component={FieldInput}
                />
              </TableCell>
            )
          }
        </TableRow>
        <TableRow>
          <TableCell variant='head' width={2} style={{ fontWeight: 'bold' }}>Comment</TableCell>
          {
            [...Array(vendorLength())].map((e, i) => 
              <TableCell>
                <Field
                  name={`vendors[${i}].comment`}
                  editable={true}
                  containerStyle={{ margin: '0px' }}
                  style={{ margin: '0px' }}
                  type={type.textArea}
                  component={FieldInput}
                />
              </TableCell>
            )
          }
        </TableRow>
      </React.Fragment>
    )
  }

  return (
    <React.Fragment>
      <Card style={{ marginTop: '10px' }}>
        <CardHeader
          title='Vendor Information'
          action={
            showCollapse ? 
            <IconButton aria-label='Expand' onClick={() => setShowVendorInfo(!showVendorInfo)}>
              {showVendorInfo ? <ExpandLess /> : <ExpandMore />}
            </IconButton> : null
          }
        />
        <Collapse in={showVendorInfo}>
          <CardContent>
            <VendorInformationContainer>
              <TableContainer style={{ marginTop: (editableForm() ? '10px' : '0px'), border: 'solid 1px #C5C5C5', borderRadius: '5px' }} component={Paper}>
                <Table>
                  <TableHead>
                    {renderVendorName()}
                  </TableHead>
                  <TableBody>
                    {renderContact()}
                    {renderAddress()}
                    {renderProposeBy()}
                    {renderYearEstablished()}
                    {renderRegisteredCapital()}
                    {renderIncome()}
                    {renderProfit()}
                    {renderShareholder()}
                    {renderExperience()}
                    {renderPqPart()}
                    {renderCommitteeEvaluationPart()}
                  </TableBody>
                </Table>
              </TableContainer>
            </VendorInformationContainer>
          </CardContent>
        </Collapse>
      </Card>
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  const username = state.authen.user ? state.authen.user.username ? state.authen.user.username : '' : ''
  return ({
    members: {
      data: state.member.members,
      loading: state.member.memberLoading
    },
    username: username,
    businessPartners: state.options.businessPartners,
  })
}

const mapDispatchToProps = {
  getHrmsMembers,
  getBusinessPartners,
  getVendorDetail,
  getAllMembers
}

const FormVendorInformation = reduxForm({
  form: 'formShortList',
  enableReinitialize: true,
})(VendorInformation)

export default connect(mapStateToProps, mapDispatchToProps)(FormVendorInformation)